import {
    faBolt,
    faCloud,
    faCloudRain,
    faCloudShowersHeavy,
    faCloudSun,
    faQuestionCircle,
    faSmog,
    faSnowflake,
    faSun,
} from "@fortawesome/free-solid-svg-icons";
import * as Sentry from "@sentry/react";
import { tempToColor } from "temp-color";
import Helper from "./Helper";

import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

const Weather = {
    getWeatherInformation(project_token: string) {
        const current_subdomain = Helper.currentUrlSubdomain();
        const url = new URL(`${Helper.baseUrlAltSubdomain(current_subdomain)}/projects/${project_token}/weather`);
        const options = {
            method: "PUT",
        };
        return Helper.plotFetch(url.toString(), options, true)
            .then((response: Response) => {
                if (response.ok) {
                    return response.json();
                }
            })
            .catch((error) => {
                Sentry.captureException(error);
                return null;
            });
    },

    getWeatherIcon(condition: string): IconDefinition {
        const c = (condition || "").toLowerCase();
        if (c.includes("clear") || c.includes("sunny")) return faSun;
        if (c.includes("partly")) return faCloudSun;
        if (c.includes("mostly")) return faCloud;
        if (c.includes("cloud")) return faCloud;
        if (c.includes("drizzle")) return faCloudRain;
        if (c.includes("rain")) return faCloudShowersHeavy;
        if (c.includes("fog")) return faSmog;
        if (c.includes("snow")) return faSnowflake;
        if (c.includes("storm") || c.includes("thunder")) return faBolt;
        return faQuestionCircle;
    },

    getTemperatureColor(temperature: number) {
        const min = 0; //lowest possible value (scale begins there)
        const max = 110; //highest possible value (scale ends there)
        const color = tempToColor(temperature, min, max);
        return `rgb(${color.r},${color.g},${color.b})`;
    },

    getLeftMarginPercentage(rangeHigh: number, rangeLow: number, minTemp: number) {
        const diff = (minTemp - rangeLow) / (rangeHigh - rangeLow);

        return (diff * 100).toFixed() + "%";
    },

    getRightMarginPercentage(rangeHigh, rangeLow, maxTemp) {
        const diff = (rangeHigh - maxTemp) / (rangeHigh - rangeLow);

        return (diff * 100).toFixed() + "%";
    },
};

export default Weather;
